/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateQuickAccessItemDocumentParamsBody } from '../model';
// @ts-ignore
import { CreateQuickAccessItemPdfParamsBody } from '../model';
// @ts-ignore
import { CreateQuickAccessItemWebParamsBody } from '../model';
// @ts-ignore
import { DeleteQuickAccessItemParamsBody } from '../model';
// @ts-ignore
import { ModifyQuickAccessItemParamsBody } from '../model';
// @ts-ignore
import { QuickAccessItem } from '../model';
// @ts-ignore
import { QuickAccessItems } from '../model';
// @ts-ignore
import { TotalCount } from '../model';
/**
 * QuickAccessApi - axios parameter creator
 * @export
 */
export const QuickAccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary クイックアクセスに文書を保存する
         * @param {CreateQuickAccessItemDocumentParamsBody} [createQuickAccessItemDocumentParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuickAccessItemDocument: async (createQuickAccessItemDocumentParamsBody?: CreateQuickAccessItemDocumentParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quick-access/item/document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuickAccessItemDocumentParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary クイックアクセスに pdf ビューのセクションを保存する
         * @param {CreateQuickAccessItemPdfParamsBody} [createQuickAccessItemPdfParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuickAccessItemPdf: async (createQuickAccessItemPdfParamsBody?: CreateQuickAccessItemPdfParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quick-access/item/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuickAccessItemPdfParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary クイックアクセスに web ビューのセクションを保存する
         * @param {CreateQuickAccessItemWebParamsBody} [createQuickAccessItemWebParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuickAccessItemWeb: async (createQuickAccessItemWebParamsBody?: CreateQuickAccessItemWebParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quick-access/item/web`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuickAccessItemWebParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary クイックアクセス要素を削除する
         * @param {string} id 削除するクイックアクセスアイテムの ID
         * @param {DeleteQuickAccessItemParamsBody} [deleteQuickAccessItemParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuickAccessItem: async (id: string, deleteQuickAccessItemParamsBody?: DeleteQuickAccessItemParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteQuickAccessItem', 'id', id)
            const localVarPath = `/quick-access/item/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteQuickAccessItemParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary クイックアクセスに含まれるアイテムの全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickAccessItemCount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quick-access/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary クイックアクセスに含まれるアイテムの一覧を得る。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickAccessItems: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quick-access/items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary クイックアクセス要素のメモなどを変更する
         * @param {string} id 変更するクイックアクセス要素の ID
         * @param {ModifyQuickAccessItemParamsBody} [modifyQuickAccessItemParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyQuickAccessItem: async (id: string, modifyQuickAccessItemParamsBody?: ModifyQuickAccessItemParamsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('modifyQuickAccessItem', 'id', id)
            const localVarPath = `/quick-access/item/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifyQuickAccessItemParamsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuickAccessApi - functional programming interface
 * @export
 */
export const QuickAccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuickAccessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary クイックアクセスに文書を保存する
         * @param {CreateQuickAccessItemDocumentParamsBody} [createQuickAccessItemDocumentParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuickAccessItemDocument(createQuickAccessItemDocumentParamsBody?: CreateQuickAccessItemDocumentParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickAccessItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuickAccessItemDocument(createQuickAccessItemDocumentParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary クイックアクセスに pdf ビューのセクションを保存する
         * @param {CreateQuickAccessItemPdfParamsBody} [createQuickAccessItemPdfParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuickAccessItemPdf(createQuickAccessItemPdfParamsBody?: CreateQuickAccessItemPdfParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickAccessItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuickAccessItemPdf(createQuickAccessItemPdfParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary クイックアクセスに web ビューのセクションを保存する
         * @param {CreateQuickAccessItemWebParamsBody} [createQuickAccessItemWebParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuickAccessItemWeb(createQuickAccessItemWebParamsBody?: CreateQuickAccessItemWebParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickAccessItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuickAccessItemWeb(createQuickAccessItemWebParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary クイックアクセス要素を削除する
         * @param {string} id 削除するクイックアクセスアイテムの ID
         * @param {DeleteQuickAccessItemParamsBody} [deleteQuickAccessItemParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuickAccessItem(id: string, deleteQuickAccessItemParamsBody?: DeleteQuickAccessItemParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuickAccessItem(id, deleteQuickAccessItemParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary クイックアクセスに含まれるアイテムの全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuickAccessItemCount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuickAccessItemCount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary クイックアクセスに含まれるアイテムの一覧を得る。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuickAccessItems(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickAccessItems>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuickAccessItems(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary クイックアクセス要素のメモなどを変更する
         * @param {string} id 変更するクイックアクセス要素の ID
         * @param {ModifyQuickAccessItemParamsBody} [modifyQuickAccessItemParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modifyQuickAccessItem(id: string, modifyQuickAccessItemParamsBody?: ModifyQuickAccessItemParamsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickAccessItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modifyQuickAccessItem(id, modifyQuickAccessItemParamsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuickAccessApi - factory interface
 * @export
 */
export const QuickAccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuickAccessApiFp(configuration)
    return {
        /**
         * 
         * @summary クイックアクセスに文書を保存する
         * @param {CreateQuickAccessItemDocumentParamsBody} [createQuickAccessItemDocumentParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuickAccessItemDocument(createQuickAccessItemDocumentParamsBody?: CreateQuickAccessItemDocumentParamsBody, options?: any): AxiosPromise<QuickAccessItem> {
            return localVarFp.createQuickAccessItemDocument(createQuickAccessItemDocumentParamsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary クイックアクセスに pdf ビューのセクションを保存する
         * @param {CreateQuickAccessItemPdfParamsBody} [createQuickAccessItemPdfParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuickAccessItemPdf(createQuickAccessItemPdfParamsBody?: CreateQuickAccessItemPdfParamsBody, options?: any): AxiosPromise<QuickAccessItem> {
            return localVarFp.createQuickAccessItemPdf(createQuickAccessItemPdfParamsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary クイックアクセスに web ビューのセクションを保存する
         * @param {CreateQuickAccessItemWebParamsBody} [createQuickAccessItemWebParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuickAccessItemWeb(createQuickAccessItemWebParamsBody?: CreateQuickAccessItemWebParamsBody, options?: any): AxiosPromise<QuickAccessItem> {
            return localVarFp.createQuickAccessItemWeb(createQuickAccessItemWebParamsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary クイックアクセス要素を削除する
         * @param {string} id 削除するクイックアクセスアイテムの ID
         * @param {DeleteQuickAccessItemParamsBody} [deleteQuickAccessItemParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuickAccessItem(id: string, deleteQuickAccessItemParamsBody?: DeleteQuickAccessItemParamsBody, options?: any): AxiosPromise<void> {
            return localVarFp.deleteQuickAccessItem(id, deleteQuickAccessItemParamsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary クイックアクセスに含まれるアイテムの全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickAccessItemCount(options?: any): AxiosPromise<TotalCount> {
            return localVarFp.getQuickAccessItemCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary クイックアクセスに含まれるアイテムの一覧を得る。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickAccessItems(options?: any): AxiosPromise<QuickAccessItems> {
            return localVarFp.getQuickAccessItems(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary クイックアクセス要素のメモなどを変更する
         * @param {string} id 変更するクイックアクセス要素の ID
         * @param {ModifyQuickAccessItemParamsBody} [modifyQuickAccessItemParamsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyQuickAccessItem(id: string, modifyQuickAccessItemParamsBody?: ModifyQuickAccessItemParamsBody, options?: any): AxiosPromise<QuickAccessItem> {
            return localVarFp.modifyQuickAccessItem(id, modifyQuickAccessItemParamsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuickAccessApi - interface
 * @export
 * @interface QuickAccessApi
 */
export interface QuickAccessApiInterface {
    /**
     * 
     * @summary クイックアクセスに文書を保存する
     * @param {CreateQuickAccessItemDocumentParamsBody} [createQuickAccessItemDocumentParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApiInterface
     */
    createQuickAccessItemDocument(createQuickAccessItemDocumentParamsBody?: CreateQuickAccessItemDocumentParamsBody, options?: AxiosRequestConfig): AxiosPromise<QuickAccessItem>;

    /**
     * 
     * @summary クイックアクセスに pdf ビューのセクションを保存する
     * @param {CreateQuickAccessItemPdfParamsBody} [createQuickAccessItemPdfParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApiInterface
     */
    createQuickAccessItemPdf(createQuickAccessItemPdfParamsBody?: CreateQuickAccessItemPdfParamsBody, options?: AxiosRequestConfig): AxiosPromise<QuickAccessItem>;

    /**
     * 
     * @summary クイックアクセスに web ビューのセクションを保存する
     * @param {CreateQuickAccessItemWebParamsBody} [createQuickAccessItemWebParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApiInterface
     */
    createQuickAccessItemWeb(createQuickAccessItemWebParamsBody?: CreateQuickAccessItemWebParamsBody, options?: AxiosRequestConfig): AxiosPromise<QuickAccessItem>;

    /**
     * 
     * @summary クイックアクセス要素を削除する
     * @param {string} id 削除するクイックアクセスアイテムの ID
     * @param {DeleteQuickAccessItemParamsBody} [deleteQuickAccessItemParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApiInterface
     */
    deleteQuickAccessItem(id: string, deleteQuickAccessItemParamsBody?: DeleteQuickAccessItemParamsBody, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary クイックアクセスに含まれるアイテムの全数カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApiInterface
     */
    getQuickAccessItemCount(options?: AxiosRequestConfig): AxiosPromise<TotalCount>;

    /**
     * 
     * @summary クイックアクセスに含まれるアイテムの一覧を得る。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApiInterface
     */
    getQuickAccessItems(options?: AxiosRequestConfig): AxiosPromise<QuickAccessItems>;

    /**
     * 
     * @summary クイックアクセス要素のメモなどを変更する
     * @param {string} id 変更するクイックアクセス要素の ID
     * @param {ModifyQuickAccessItemParamsBody} [modifyQuickAccessItemParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApiInterface
     */
    modifyQuickAccessItem(id: string, modifyQuickAccessItemParamsBody?: ModifyQuickAccessItemParamsBody, options?: AxiosRequestConfig): AxiosPromise<QuickAccessItem>;

}

/**
 * QuickAccessApi - object-oriented interface
 * @export
 * @class QuickAccessApi
 * @extends {BaseAPI}
 */
export class QuickAccessApi extends BaseAPI implements QuickAccessApiInterface {
    /**
     * 
     * @summary クイックアクセスに文書を保存する
     * @param {CreateQuickAccessItemDocumentParamsBody} [createQuickAccessItemDocumentParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApi
     */
    public createQuickAccessItemDocument(createQuickAccessItemDocumentParamsBody?: CreateQuickAccessItemDocumentParamsBody, options?: AxiosRequestConfig) {
        return QuickAccessApiFp(this.configuration).createQuickAccessItemDocument(createQuickAccessItemDocumentParamsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary クイックアクセスに pdf ビューのセクションを保存する
     * @param {CreateQuickAccessItemPdfParamsBody} [createQuickAccessItemPdfParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApi
     */
    public createQuickAccessItemPdf(createQuickAccessItemPdfParamsBody?: CreateQuickAccessItemPdfParamsBody, options?: AxiosRequestConfig) {
        return QuickAccessApiFp(this.configuration).createQuickAccessItemPdf(createQuickAccessItemPdfParamsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary クイックアクセスに web ビューのセクションを保存する
     * @param {CreateQuickAccessItemWebParamsBody} [createQuickAccessItemWebParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApi
     */
    public createQuickAccessItemWeb(createQuickAccessItemWebParamsBody?: CreateQuickAccessItemWebParamsBody, options?: AxiosRequestConfig) {
        return QuickAccessApiFp(this.configuration).createQuickAccessItemWeb(createQuickAccessItemWebParamsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary クイックアクセス要素を削除する
     * @param {string} id 削除するクイックアクセスアイテムの ID
     * @param {DeleteQuickAccessItemParamsBody} [deleteQuickAccessItemParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApi
     */
    public deleteQuickAccessItem(id: string, deleteQuickAccessItemParamsBody?: DeleteQuickAccessItemParamsBody, options?: AxiosRequestConfig) {
        return QuickAccessApiFp(this.configuration).deleteQuickAccessItem(id, deleteQuickAccessItemParamsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary クイックアクセスに含まれるアイテムの全数カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApi
     */
    public getQuickAccessItemCount(options?: AxiosRequestConfig) {
        return QuickAccessApiFp(this.configuration).getQuickAccessItemCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary クイックアクセスに含まれるアイテムの一覧を得る。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApi
     */
    public getQuickAccessItems(options?: AxiosRequestConfig) {
        return QuickAccessApiFp(this.configuration).getQuickAccessItems(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary クイックアクセス要素のメモなどを変更する
     * @param {string} id 変更するクイックアクセス要素の ID
     * @param {ModifyQuickAccessItemParamsBody} [modifyQuickAccessItemParamsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickAccessApi
     */
    public modifyQuickAccessItem(id: string, modifyQuickAccessItemParamsBody?: ModifyQuickAccessItemParamsBody, options?: AxiosRequestConfig) {
        return QuickAccessApiFp(this.configuration).modifyQuickAccessItem(id, modifyQuickAccessItemParamsBody, options).then((request) => request(this.axios, this.basePath));
    }
}
